import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { ProductionStatus } from 'models/order';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

type ProductionStatusDropdownProps = {
    production: ProductionStatus;
    onProductionStatusChange: (status: ProductionStatus) => void;
};

export const ProductionStatusDropdown: FC<ProductionStatusDropdownProps> = ({
    production,
    onProductionStatusChange,
}) => {
    const { t: translate } = useTranslation(['orders', 'common']);
    return (
        <FormControl fullWidth>
            <InputLabel id="production-select-label">{translate('orders:PRODUCTION')}</InputLabel>
            <Select
                value={production || ProductionStatus.ALL}
                onChange={(event: SelectChangeEvent) =>
                    onProductionStatusChange(event.target.value as ProductionStatus)
                }
                labelId="production-select-label"
                label={translate('orders:PRODUCTION')}
            >
                {Object.values(ProductionStatus).map((production, index) => {
                    return (
                        <MenuItem key={index} value={production}>
                            {translate(production)}
                        </MenuItem>
                    );
                })}
            </Select>
        </FormControl>
    );
};
